import { Children } from 'react';
import { Box, Typography } from '@mui/material';

import { getThemeColor } from '../../utils/common';
import { FORTA_BLUE, FORTA_WHITE } from '../../utils/colors';
import { Themes } from '../../constants';

import type { ReactNode } from 'react';
import type { ITableHeaderConfig } from '../../utils/types';

interface FHTableContainerProps {
  children?: ReactNode;
  colorTheme?: Themes;
  sx?: any;
  headerStyle?: any;
  contentStyle?: any;
  headerConfig?: Array<ITableHeaderConfig>;
}

function FHTableContainer(props: FHTableContainerProps) {
  const {
    children,
    sx,
    headerStyle = {},
    contentStyle = {},
    headerConfig,
    colorTheme = Themes.Primary,
  } = props;

  return (
    <Box
      data-testid="fh-table-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: getThemeColor(colorTheme).light3,
        borderRadius: '10px',
        ...sx,
      }}
    >
      {Boolean(headerConfig?.length) && (
        <Box
          data-testid="fh-table-header"
          sx={{
            display: 'flex',
            borderRadius: '16px',
            height: 40,
            flexGrow: 1,
            width: 'calc(100% + 4px)',
            marginLeft: '-10px',
            px: 3,
            ...headerStyle,
          }}
        >
          {headerConfig?.length &&
            headerConfig?.map((conf: ITableHeaderConfig) => {
              return (
                <Box
                  sx={{ display: 'flex', py: 0.5, alignItems: 'center', ...conf.sx }}
                  key={conf.label}
                >
                  <Typography
                    fontWeight={700}
                    variant={conf.labelWeight ? conf.labelWeight : 'body1'}
                    textAlign={conf.labelAlign ? conf.labelAlign : 'center'}
                    sx={{ flexGrow: 1 }}
                    color={conf.labelColor ? conf.labelColor : FORTA_BLUE.primary}
                  >
                    {conf.label}
                  </Typography>
                  {conf.showRightBorder && (
                    <Box
                      sx={{
                        height: '100%',
                        borderLeft: `2px solid ${getThemeColor(colorTheme).light2}`,
                        borderRadius: '4px',
                      }}
                    ></Box>
                  )}
                </Box>
              );
            })}
        </Box>
      )}
      <Box
        data-testid="fh-table-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '16px',
          overflow: 'hidden',
          backgroundColor: FORTA_WHITE,
          ...contentStyle,
        }}
      >
        {Children.map(children, (child) => (
          <Box className="table-row">{child}</Box>
        ))}
      </Box>
    </Box>
  );
}

export default FHTableContainer;
